import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ChangeSection = Loadable(
  lazy(() => import("features/changeSection/components/ChangeSection"))
);

const routes = {
  path: "changeSection",
  children: [{ path: "", element: <ChangeSection /> }],
};

export default routes;
